import React from 'react'
import { Link } from 'gatsby'
import moment from 'moment'
import styled from 'styled-components'

import mark from '../img/mark.png'

const FooterWrapper = styled.footer`
  background-color: #ffe7e0;
  color: #ad847d;
  border-top: 0.5rem solid #fbf480;
`

const FooterBody = styled.div`
  max-width: 60rem;
  margin: 0 auto;
  padding: 1rem 0;
`

const FooterNav = styled.ul`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0;
  padding: 0;
`

const FooterNavItem = styled.li`
  display: block;
`

const FooterNavLink = styled(Link)`
  display: block;
  font-family: mr-eaves-modern;
  font-size: 1.1rem;
  letter-spacing: 0.2em;
  padding: 2rem 1em;
  text-decoration: none;
  text-transform: uppercase;
`

const FooterNavItemLink = props => (
  <FooterNavItem>
    <FooterNavLink {...props} />
  </FooterNavItem>
)

const FooterNavA = styled.a`
  display: block;
  font-family: mr-eaves-modern;
  font-size: 1.1rem;
  letter-spacing: 0.2em;
  padding: 2rem 1em;
  text-decoration: none;
  text-transform: uppercase;
`

const CopyrightStyle = styled.div`
  font-size: 0.75rem;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  margin: 2.5rem 1rem 1rem;
`

const Copyright = () => (
  <CopyrightStyle>
    Copyright {moment().format('YYYY')} One & Only Paper. All rights reserved
  </CopyrightStyle>
)

const Logo = styled.img`
  display: block;
  width: 5rem;
  margin: 0 auto;
`

const links = [
  { name: 'Inquire', url: 'https://oopaperco.typeform.com/to/xFYdSd', type: 'a' },
  { name: 'About', url: '/#about', type: 'a' },
  { name: 'Blog', url: '/blog' },
  { name: 'Shop', url: 'https://shop.oneandonlypaper.com/', type: 'a' },
  { name: 'Login', url: '/admin/', type: 'a' },
]

const Footer = () => (
  <FooterWrapper>
    <FooterBody>
      <FooterNav>
        {links.map(({ name, url, type }) =>
          type == 'a' ? (
            <FooterNavA key={url} href={url}>
              {name}
            </FooterNavA>
          ) : (
            <FooterNavItemLink key={url} to={url}>
              {name}
            </FooterNavItemLink>
          )
        )}
      </FooterNav>
      <Logo src={mark} />
      <Copyright />
    </FooterBody>
  </FooterWrapper>
)

export default Footer
